module.exports = new __parcel__URL__("changesDark.e78f0f3f.svg").toString();